module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "topbar-wrap",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "topbar-title"
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "color": "#fff"
    }
  }, [_vm._v("神州联保师傅小店系统管理后台")]), _vm._v(" "), _c('div', {
    staticClass: "menu-toggle",
    on: {
      "click": _vm.collapse
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCollapse),
      expression: "!isCollapse"
    }],
    staticClass: "icon iconfont icon-menufold"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCollapse),
      expression: "isCollapse"
    }],
    staticClass: "icon iconfont icon-menuunfold"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "topbar-account topbar-btn"
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_vm._v("\n                    " + _vm._s(_vm.nickname) + " "), _c('i', {
    staticClass: "icon iconfont icon-user"
  }), _vm._v(" "), _c('i', {
    staticClass: "icon iconfont icon-down"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    class: {
      showSidebar: !_vm.isCollapse
    }
  }, [_c('el-menu', {
    ref: "menu",
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "text-color": "#fff",
      "default-active": _vm.activeIndex,
      "unique-opened": "",
      "router": "",
      "collapse": _vm.isCollapse
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/home"
    }
  }, [_c('i', {
    staticClass: "icon iconfont el-icon-home"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("首页")])]), _vm._v(" "), _vm._l((_vm.menusList), function(item) {
    return [(item.children) ? _c('el-submenu', {
      key: item.id,
      attrs: {
        "index": item.menu_url
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      staticClass: "icon iconfont",
      class: item.icon
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.menu_name))])]), _vm._v(" "), _vm._l((item.children), function(child) {
      return _c('el-menu-item', {
        key: child.id,
        attrs: {
          "index": child.menu_url
        }
      }, [_vm._v(_vm._s(child.menu_name))])
    })], 2) : _c('el-menu-item', {
      key: item.id,
      attrs: {
        "index": item.menu_url
      }
    }, [_c('i', {
      staticClass: "icon iconfont",
      class: item.icon
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.menu_name))])])]
  })], 2)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.name,
      "mode": _vm.mode
    }
  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.name,
      "mode": _vm.mode
    }
  }, [(_vm.activeIndex == '/home') ? _c('el-alert', {
    attrs: {
      "title": "神州联保师傅小店系统管理后台",
      "type": "success",
      "center": "",
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c79b47ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/home.vue
// module id = 723
// module chunks = 28